import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreateExpertLevelRequest } from "@shopexperts/legacy-api";

export function useCreateAdminExpertLevel() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "expert-levels", "create"],
    mutationFn: async (body: CreateExpertLevelRequest) => {
      return await api.admin.expertLevels.createLevel({ body });
    },
    onSuccess: () => {
      toaster.create({ title: "Expert level created successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels"] });
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to create expert level: ${error.message}`, type: "error" });
    },
  });
}
